(function () {
  function run() {
    document.querySelectorAll('[id*="section_store_block_bundle"]').forEach(function (wrap) {
      var bundleEl = wrap.querySelector('section-store--bundle-block[data-short-ids]');
      var ids = bundleEl ? bundleEl.getAttribute('data-short-ids') : '';
      var hasBundle = !!(ids && ids.trim().length);
      if (!hasBundle) return;
      var scope = wrap.closest('.shopify-section') || document;
      var optionsBlock = scope.querySelector('[data-block-id="options"]');
      var quantityBlock = scope.querySelector('[data-block-id="quantity"]');
      if (optionsBlock) optionsBlock.style.display = 'none';
      if (quantityBlock) quantityBlock.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
})();